<div class="html-container">
  <span class="search-highlight" [innerHTML]="_value || (showPlaceholderIfEmpty ? '-' : '') | iconReplace"></span>
</div>
